import React from 'react';
import PropTypes from 'prop-types';
import {useRouter} from '@computerrock/formation-router';
import {useTranslate} from '@computerrock/formation-i18n';
import {Modal, HighlightCircle, useStyles, ButtonSecondary} from '@ace-de/ui-components';
import {Icon, InteractiveIcon, closeIcon, warningIcon} from '@ace-de/ui-components/icons';
import modalIds from '../../modalIds';

const FetchUserDataFailedWarningModal = ({hasBackdrop}) => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const {closeModal} = useRouter();
    const translateModal = createTranslateShorthand('fetch_user_data_failed_warning_modal');

    return (
        <Modal
            hasBackdrop={hasBackdrop}
            action={(
                <InteractiveIcon
                    icon={closeIcon}
                    onClick={() => closeModal(modalIds.FETCH_USER_DATA_FAILED_WARNING)}
                />
            )}
        >
            <div
                className={cx([
                    'global!ace-u-flex',
                    'global!ace-u-flex--direction-column',
                    'global!ace-u-flex--justify-center',
                    'global!ace-u-flex--align-center',
                    'global!ace-u-full-width',
                ])}
            >
                <HighlightCircle
                    className={cx([
                        'ace-c-highlight-circle--medium',
                        'global!ace-u-margin--bottom-32',
                        'ace-c-highlight-circle--warning',
                    ])}
                >
                    <Icon
                        icon={warningIcon}
                        className={cx([
                            'ace-c-icon--xxl',
                            'ace-c-icon--color-warning',
                        ])}
                    />
                </HighlightCircle>
                <p className={cx('global!ace-u-margin--bottom-32')}>
                    {translateModal('error_message')}
                </p>
                <ButtonSecondary
                    onClick={() => closeModal(modalIds.FETCH_USER_DATA_FAILED_WARNING)}
                >
                    {translateModal('button.close')}
                </ButtonSecondary>
            </div>
        </Modal>
    );
};

FetchUserDataFailedWarningModal.propTypes = {
    hasBackdrop: PropTypes.bool,
};

FetchUserDataFailedWarningModal.defaultProps = {
    hasBackdrop: true,
};

export default FetchUserDataFailedWarningModal;

